import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ec445b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between items-center mb-8" }
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "flex flex-row gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "rounded-md bg-slate-200 px-3.5 py-2.5 text-sm font-semibold text-slate-500 shadow-sm hover:bg-slate-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
}, " Arşiv", -1))
const _hoisted_5 = { class: "relative flex flex-col w-full h-full overflow-scroll text-gray-700 bg-white shadow-md rounded-lg bg-clip-border" }
const _hoisted_6 = { class: "w-full text-left table-auto min-w-max text-slate-800" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-slate-500 border-b border-slate-300 bg-slate-50" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-4 w-24" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-none font-normal" }, " Öğrenci ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-none font-normal" }, " Okul Numarası ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-none font-normal" }, " Kayıt Tarihi ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-none font-normal" }, " Son Veri Giriş Tarihi ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, [
      /*#__PURE__*/_createElementVNode("p")
    ])
  ])
], -1))
const _hoisted_8 = { class: "p-4 w-10" }
const _hoisted_9 = { class: "p-4" }
const _hoisted_10 = { class: "text-sm font-bold" }
const _hoisted_11 = { class: "p-4" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "p-4" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "p-4 text-right" }
const _hoisted_18 = {
  key: 0,
  colspan: "6",
  class: "p-4 text-center h-32"
}
const _hoisted_19 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
}
const _hoisted_20 = { class: "bg-white p-6 rounded-lg shadow-lg max-w-lg w-full" }
const _hoisted_21 = { class: "flex justify-between items-center mb-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold" }, "Yeni Öğrenci", -1))
const _hoisted_23 = { class: "flex justify-between" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rounded-md px-3.5 py-2.5 text-sm font-semibold text-red-500 hover: bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" }, "Arşivle", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.ClassRoom?.name) + " Öğrenci Listesi", 1),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSettingsDialog && _ctx.openSettingsDialog(...args))),
          class: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        }, " Sınıfa Öğrenci Ekleyin")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Students, (item, classIndex) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: classIndex,
              class: "hover:bg-slate-50"
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_component_Avatar, {
                  photoUrl: item.photoUrl,
                  name: item.name,
                  surname: item.surname
                }, null, 8, ["photoUrl", "name", "surname"])
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(item.name) + " " + _toDisplayString(item.middleName) + " " + _toDisplayString(item.surname), 1)
              ]),
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(item.schoolNumber), 1)
              ]),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(item.createdAt), 1)
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(item.lastDataEntryDate), 1)
              ]),
              _createElementVNode("td", _hoisted_17, [
                _createVNode(_component_router_link, {
                  to: `/classRoom/${_ctx.route.params.id}/${item.studentId}`,
                  class: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Veri Girişi ")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_component_router_link, {
                  to: `/chat?crid=${_ctx.route.params.id}&sid=${item.studentId}`,
                  class: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" CHAT ")
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            (_ctx.Students.length == 0)
              ? (_openBlock(), _createElementBlock("td", _hoisted_18, " Bu sınıfa henüz öğrenci kayıt edilmemiş. "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.showSettingsDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSettingsDialog && _ctx.closeSettingsDialog(...args))),
                class: "text-red-500 text-sm"
              }, " Kapat ")
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Student.schoolNumber) = $event)),
              placeholder: "Okul Numarası",
              class: "input input-bordered w-full mb-4"
            }, null, 512), [
              [_vModelText, _ctx.Student.schoolNumber]
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.AddStudentToClassRoom && _ctx.AddStudentToClassRoom(...args))),
                class: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              }, "Kaydet")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}